export default {
  /**
   * http://mathworld.wolfram.com/Implies.html
   * @param {Boolean} conditionA
   */
  if(conditionA) {
    return {
      /**
       * @param {Boolean} conditionB
       */
      then(conditionB) {
        return !conditionA || !!conditionB;
      },
    };
  },
};
